/* IMPORT */
import isObservable from './is_observable.js';
import { isFunction } from '../utils.js';
function get(value, getFunction = true) {
    const is = getFunction ? isFunction : isObservable;
    if (is(value)) {
        return value();
    }
    else {
        return value;
    }
}
/* EXPORT */
export default get;
